import Cookies from 'js-cookie';

export const getAccountData = () => {
  const rawData = Cookies.get('accountData'); // Obtiene la cookie en string
  if (!rawData) return null;

  try {
    return JSON.parse(decodeURIComponent(rawData)); // Decodifica y convierte en objeto
  } catch (error) {
    console.error('Error parsing accountData:', error);
    return null;
  }
};



export const userData = () => {
  const rawData = Cookies.get('userData'); // Obtiene la cookie en string
  if (!rawData) return null;

  try {
    return JSON.parse(decodeURIComponent(rawData)); // Decodifica y convierte en objeto
  } catch (error) {
    console.error('Error parsing accountData:', error);
    return null;
  }
};